"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var fp_1 = require("date-fns/fp");
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var date_fns_1 = require("date-fns");
var CalendarBaseInput_1 = tslib_1.__importDefault(require("../CalendarBaseInput"));
var CalendarBaseHeader = function (props) {
    var startDate = props.startDate, _a = props.undefinedStartDateText, undefinedStartDateText = _a === void 0 ? 'MM/DD/YYYY' : _a, endDate = props.endDate, _b = props.undefinedEndDateText, undefinedEndDateText = _b === void 0 ? 'MM/DD/YYYY' : _b, _c = props.onStartDateChange, onStartDateChange = _c === void 0 ? noop_1.default : _c, _d = props.onEndDateChange, onEndDateChange = _d === void 0 ? noop_1.default : _d, _e = props.isRange, isRange = _e === void 0 ? false : _e, _f = props.calendarType, calendarType = _f === void 0 ? 'day' : _f, _g = props.isValidStartDate, isValidStartDate = _g === void 0 ? true : _g, _h = props.isValidEndDate, isValidEndDate = _h === void 0 ? true : _h, _j = props.leftIsActive, leftIsActive = _j === void 0 ? true : _j, startDateLabel = props.startDateLabel, endDateLabel = props.endDateLabel, _k = props.onStartDateClick, onStartDateClick = _k === void 0 ? noop_1.default : _k, _l = props.onEndDateClick, onEndDateClick = _l === void 0 ? noop_1.default : _l, _m = props.closeButton, closeButton = _m === void 0 ? false : _m, _o = props.handleCancel, handleCancel = _o === void 0 ? noop_1.default : _o;
    var startLabel = startDateLabel || (isRange ? 'Start' : 'Date');
    var inputType = calendarType === 'day' ? 'date' : 'month';
    var startInputType = startDate ? inputType : 'text';
    var endInputType = endDate ? inputType : 'text';
    var changeStartDate = react_1.useCallback(function (newDate) {
        if (Date.parse(newDate.value)) {
            var dateFormatVal = fp_1.parse(new Date(), 'yyyy-MM-dd', newDate.value);
            onStartDateChange(dateFormatVal);
        }
    }, [onStartDateChange]);
    var changeEndDate = react_1.useCallback(function (newDate) {
        if (Date.parse(newDate.value)) {
            var dateFormatVal = fp_1.parse(new Date(), 'yyyy-MM-dd', newDate.value);
            onEndDateChange(dateFormatVal);
        }
    }, [onEndDateChange]);
    var formatValue = function (date) {
        return inputType === 'month'
            ? fp_1.format('yyyy-MM', date)
            : fp_1.format('yyyy-MM-dd', date);
    };
    var handleStartChange = react_1.useCallback(function (event) {
        changeStartDate(event.target);
    }, [changeStartDate]);
    var handleEndChange = react_1.useCallback(function (event) {
        changeEndDate(event.target);
    }, [changeEndDate]);
    var handleOnStartDateClick = react_1.useCallback(function (value) {
        if (startInputType === 'text') {
            onStartDateChange(endDate ? date_fns_1.startOfMonth(endDate) : new Date());
        }
        onStartDateClick(value);
    }, [onStartDateChange, onStartDateClick, endDate, startInputType]);
    var handleOnEndDateClick = react_1.useCallback(function (value) {
        if (endInputType === 'text') {
            onEndDateChange(new Date());
        }
        onEndDateClick(value);
    }, [onEndDateChange, onEndDateClick, endInputType]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledTabs, null,
            react_1.default.createElement(CalendarBaseInput_1.default, { active: leftIsActive, onClick: handleOnStartDateClick, value: startDate ? formatValue(startDate) : undefinedStartDateText, onChange: handleStartChange, label: startLabel, type: startInputType, valid: isValidStartDate }),
            isRange && (react_1.default.createElement(CalendarBaseInput_1.default, { active: !leftIsActive, onClick: handleOnEndDateClick, value: endDate ? formatValue(endDate) : undefinedEndDateText, onChange: handleEndChange, label: endDateLabel || 'End', type: endInputType, valid: isValidEndDate })),
            closeButton && (react_1.default.createElement(StyledIcon, { onClick: handleCancel, className: "icon--close" })))));
};
exports.default = CalendarBaseHeader;
var StyledTabs = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  border-bottom: ", ";\n  padding: 0 1.2rem;\n"], ["\n  color: ", ";\n  border-bottom: ",
    ";\n  padding: 0 1.2rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.NTDarkGrey[200];
});
var StyledIcon = styled_components_1.default.i(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  float: right;\n"], ["\n  float: right;\n"])));
var templateObject_1, templateObject_2;
